import "./App.css";
import AppRouter from "./AppRouter";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
//import useDevice from "./hooks/useDevice";

function App() {
  //const { isDesktop } = useDevice();
  //const marginTop = isDesktop ? "120px" : "85px"; //style={{ marginTop: marginTop }}
  return (
    <>
      <Header />
      <main>
        <AppRouter />
      </main>
      <Footer />
    </>
  );
}

export default App;
